/**
 * Suggested reasons a pregnancy ended (KIN-1942).
 *
 * Suggestions, not a closed list, and the field stays free text. There is no published code set
 * to draw on — MN-CMS models a delivery and records its outcome as one coded identifier carrying
 * uncoded text, and no HSE source codes miscarriage, termination, ectopic or stillbirth. A
 * dropdown would force a GP to record the wrong thing the first time reality does not fit it.
 *
 * Offering them still matters: most entries then land on the same wording, which is what makes
 * the column worth reading later.
 *
 * A completion written by a maternity discharge summary (KIN-1926) stores the hospital's own
 * wording verbatim, so anything displaying this must cope with text that is not on this list.
 */
export const COMPLETION_REASON_SUGGESTIONS = [
  "Live birth",
  "Stillbirth",
  "Miscarriage",
  "Termination",
  "Ectopic pregnancy",
];
